module.exports = __webpack_public_path__ + "img/controller-move.ea7db72a.svg";